/* tslint:disable */
/* eslint-disable */
export enum G4AfregningerHaltedActionEnum {
  None = 'None',
  Retry = 'Retry',
  Cancel = 'Cancel',
  FinishUp = 'FinishUp'
}
